import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unshift.js";
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5f701282"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "out-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "flex": "1",
    "flex-direction": "column"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "margin-left": "16px",
    "margin-bottom": "16px"
  }
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "flex": "1"
  }
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "620px",
    "box-shadow": "0px 0px 10px 0px #f7f8ff",
    "background": "#fff",
    "margin": "0px 16px 16px 16px"
  }
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "16px 0px 0px 16px",
    "color": "rgba(35, 35, 35, 1)"
  }
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "活动参与度", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "margin": "16px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "height": "20px",
    "font-size": "12px",
    "color": "#000",
    "line-height": "20px",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, "数量(个)"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "14px",
    "height": "11px",
    "margin-right": "5px",
    "background": "linear-gradient(\n                              to top,\n                              rgba(47, 95, 254, 1),\n                              rgba(181, 198, 255, 1)\n                            )"
  }
}), /*#__PURE__*/_createElementVNode("div", null, "整体店铺参与度")]), /*#__PURE__*/_createElementVNode("div", {
  id: "containerStore",
  style: {
    "flex": "1"
  }
})]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "margin": "16px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "height": "20px",
    "font-size": "12px",
    "color": "#000",
    "line-height": "20px",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, "数量(个)"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "14px",
    "height": "11px",
    "margin-right": "5px",
    "background": "linear-gradient(\n                              to top,\n                              rgba(155, 239, 175, 1),\n                              rgba(44, 187, 93, 1)\n                            )"
  }
}), /*#__PURE__*/_createElementVNode("div", null, "整体点位参与度")]), /*#__PURE__*/_createElementVNode("div", {
  id: "containerStoreLocation",
  style: {
    "flex": "1"
  }
})])], -1));
const _hoisted_10 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "background-color": "white",
    "box-shadow": "0px 0px 10px 0px #f7f8ff"
  }
};
const _hoisted_11 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "16px 0px 0px 16px",
    "color": "rgba(35, 35, 35, 1)"
  }
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "店铺数据分析", -1));
const _hoisted_13 = {
  style: {
    "height": "150px",
    "margin": "15px",
    "display": "flex",
    "align-items": "center",
    "flex-direction": "column",
    "border-radius": "10px",
    "border": "solid 1px rgba(215, 212, 212, 1)",
    "position": "relative"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin": "15px 0px 2px 0px",
    "font-size": "13px",
    "color": "rgba(59, 113, 184, 1)"
  }
}, " 店铺类型数量统计 ", -1));
const _hoisted_15 = {
  style: {
    "display": "flex",
    "width": "100%",
    "position": "relative"
  }
};
const _hoisted_16 = {
  style: {
    "display": "flex",
    "position": "absolute",
    "left": "0px",
    "right": "0px",
    "padding-bottom": "10px",
    "overflow-x": "auto"
  }
};
const _hoisted_17 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "margin": "15px 15px 10px 15px"
  }
};
const _hoisted_18 = {
  style: {
    "font-size": "36px",
    "color": "rgba(59, 113, 184, 1)"
  }
};
const _hoisted_19 = {
  style: {
    "font-size": "12px",
    "color": "#2ecee7"
  }
};
const _hoisted_20 = {
  style: {
    "font-size": "14px",
    "color": "#3b71b8",
    "margin-top": "10px"
  }
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "position": "absolute",
    "left": "15px",
    "right": "15px",
    "top": "102px",
    "height": "1px",
    "background-color": "rgba(59, 113, 184, 1)"
  }
}, null, -1));
const _hoisted_22 = {
  style: {
    "flex": "1",
    "margin-left": "15px",
    "margin-right": "15px",
    "display": "flex"
  }
};
const _hoisted_23 = {
  style: {
    "flex": "1",
    "border-radius": "10px",
    "border": "1px solid rgb(215, 212, 212)",
    "margin-right": "15px",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "margin-bottom": "10px"
  }
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#3b71b8",
    "font-size": "36px",
    "margin-top": "10px"
  }
}, " 4002 ", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1px",
    "width": "200px",
    "background-color": "#3b71b8",
    "margin": "10px 0px"
  }
}, null, -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#3b71b8",
    "font-size": "13px",
    "margin-bottom": "10px"
  }
}, " 参与活动数量>=4次/年 ", -1));
const _hoisted_27 = {
  style: {
    "display": "flex",
    "font-size": "12px",
    "margin-bottom": "10px"
  }
};
const _hoisted_28 = {
  style: {
    "flex": "1",
    "width": "100%",
    "position": "relative"
  }
};
const _hoisted_29 = {
  style: {
    "position": "absolute",
    "inset": "0",
    "overflow-y": "auto",
    "display": "flex",
    "flex-direction": "column",
    "margin": "0px 10px"
  }
};
const _hoisted_30 = {
  style: {
    "white-space": "nowrap",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_31 = {
  style: {
    "margin-left": "auto"
  }
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "background-color": "green",
    "width": "400px",
    "border-radius": "10px",
    "border": "1px solid rgb(215, 212, 212)",
    "margin-bottom": "10px"
  }
}, null, -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "flex": "1",
    "flex-direction": "column",
    "overflow": "hidden"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "container",
  style: {
    "flex": "1"
  }
})], -1));
import { ref, reactive, onMounted, getCurrentInstance, watch, nextTick, createVNode, h, computed, onBeforeUnmount } from "vue";
import util from "@/util/util";
import permission from "@/util/permission";
import { Modal, message, Divider, Button } from "ant-design-vue";
import { DownCircleOutlined, PlusOutlined, ExclamationCircleOutlined, CheckOutlined, EditOutlined, CloseOutlined } from "@ant-design/icons-vue";
import ResizePane from "@/components/ResizePane.vue";
import dayjs from "dayjs";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import showConfirmModal from "@/util//showConfirmModal";
import { VueCropper } from "vue-cropper";
import { genFileId } from "element-plus";
import axios from "axios";
import useClipboard from "vue-clipboard3";
import { Chart } from "@antv/g2";

import { ElNotification } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
export default {
  __name: 'ActivityReport',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const {
      toClipboard
    } = useClipboard();
    const route = useRoute();
    const router = useRouter();
    const tokenData = util.getToken();
    const activeTabsKey = ref("1");
    const activityData = reactive({
      activityFormData: {
        activityCategoryId: 1,
        activityDateValue: null,
        storeTypeName: "All"
      },
      activityStoreTypeCount: [],
      filterActivityStoreTypeCount: [],
      activityCategoryList: [],
      activityStoreRankCount: [],
      filterActivityStoreRankCount: [],
      storeTypeData: ["All"]
    });
    const isTop50 = ref(true);
    const data = [{
      date: "2007/4/28-1",
      close: 93.24
    }, {
      date: "2007/4/28-2",
      close: 95.35
    }, {
      date: "2007/4/28-3",
      close: 98.84
    }, {
      date: "2007/4/29-1",
      close: 99.92
    }, {
      date: "2007/4/30-1",
      close: 99.8
    }, {
      date: "2007/5/1-1",
      close: 99.47
    }, {
      date: "2007/5/1-2",
      close: 100.39
    }, {
      date: "2007/5/2-1",
      close: 100.4
    }, {
      date: "2007/5/3-1",
      close: 100.81
    }, {
      date: "2007/5/4-1",
      close: 103.92
    }];

    // 1. 预处理数据，计算x坐标
    const mainDates = [];
    const dateMap = {};

    // 统计主日期顺序和子点数量
    data.forEach(d => {
      const [mainDate] = d.date.split(/-/);
      if (!dateMap[mainDate]) {
        dateMap[mainDate] = {
          count: 0,
          index: mainDates.length
        };
        mainDates.push(mainDate);
      }
      dateMap[mainDate].count++;
    });

    // 计算每个点的x坐标
    const processedData = data.map(d => {
      const [mainDate, subId] = d.date.split(/-/);
      const {
        index,
        count
      } = dateMap[mainDate];
      const position = index + parseInt(subId) / (count + 1);
      return {
        ...d,
        xPos: position
      };
    });
    onMounted(async () => {
      let activityCategoryList = await getActivityCategory();
      if (activityCategoryList == null) {
        return;
      }
      activityData.activityCategoryList = activityCategoryList;
      let storeTypeList = await getStoreTypeNameDict();
      if (storeTypeList == null) {
        return;
      }
      activityData.storeTypeData.push(...storeTypeList);
      activityData.activityFormData.activityDateValue = [dayjs().subtract(1, "year"),
      // 开始时间：一年前
      dayjs() // 结束时间：当前时间
      ];

      pickerChange([dayjs().subtract(1, "year").format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")]);

      // 2. 创建图表
      const chart = new Chart({
        container: "container",
        autoFit: true
      });
      chart.line().data(processedData).encode("x", "xPos").encode("y", "close");

      // 3. 关键修正：设置正确的坐标轴范围和样式
      chart.scale("xPos", {
        type: "linear",
        ticks: mainDates.map((_, i) => i + 0.5),
        // 刻度居中
        formatter: xPos => mainDates[Math.floor(xPos)],
        // 显示主日期
        range: [0, mainDates.length],
        // 范围覆盖所有主日期
        nice: true
      });

      // 4. 显式配置坐标轴标签样式（防止颜色透明）
      chart.axis("xPos", {
        label: {
          style: {
            fill: "#333",
            // 确保标签颜色可见
            fontSize: 12
          },
          autoRotate: true // 防止标签重叠
        }
      });

      // chart.render();
    });

    const getActivityCategory = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivityCategory(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityCreate.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityCount = async activityCountRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivityCount(activityCountRO).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityCreate.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getStoreTypeNameDict = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreTypeNameDict(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const pickerChange = async (dates, dateStrings) => {
      let activityCountRO = {
        activityBegin: dates[0],
        activityEnd: dates[1]
      };
      let activityCountVO = await getActivityCount(activityCountRO);
      activityData.activityStoreTypeCount = activityCountVO.activityStoreTypeCount;
      activityData.activityStoreRankCount = activityCountVO.activityStoreRankCount;
      filterTopRank();
      refreshStoreTypeCount();
      // 初始化图表实例
      const chartStore = new Chart({
        container: "containerStore",
        autoFit: true
      });
      // 声明可视化
      chartStore.interval() // 创建一个 Interval 标记
      .data(activityCountVO.activityStoreCount) // 绑定数据
      .encode("x", "month") // 编码 x 通道
      .encode("y", "quantity") // 编码 y 通道
      .encode("size", 24).axis("x", {
        labelFill: "black",
        labelFontSize: 10,
        title: null,
        // 隐藏 Y 轴标题
        title: null // 隐藏 X 轴标题
      }).axis("y", {
        labelFill: "black",
        labelFontSize: 10,
        title: null // 隐藏 Y 轴标题
      }).style("fill", "l(270) 0:rgba(47, 95, 254, 1) 1:rgba(181, 198, 255, 1)");
      // 渲染可视化
      chartStore.render();
      // 初始化图表实例
      const chartStoreLocation = new Chart({
        container: "containerStoreLocation",
        autoFit: true
      });
      // 声明可视化
      chartStoreLocation.interval() // 创建一个 Interval 标记
      .data(activityCountVO.activityStoreLocationCount) // 绑定数据
      .encode("x", "month") // 编码 x 通道
      .encode("y", "quantity") // 编码 y 通道
      .encode("size", 24).axis("x", {
        labelFill: "black",
        labelFontSize: 10,
        title: null,
        // 隐藏 Y 轴标题
        title: null // 隐藏 X 轴标题
      }).axis("y", {
        labelFill: "black",
        labelFontSize: 10,
        title: null // 隐藏 Y 轴标题
      }).style("fill", "l(270) 0:rgba(155, 239, 175, 1) 1:rgba(44, 187, 93, 1)");
      // 渲染可视化
      chartStoreLocation.render();
    };
    const changeTab = value => {
      debugger;
    };
    const refreshStoreTypeCount = () => {
      activityData.filterActivityStoreTypeCount.length = 0;
      let otherStoreTypeCount = {
        storeTypeName: "Other",
        quantity: 0
      };
      let totalStoreTypeCount = {
        storeTypeName: "Total",
        quantity: 0
      };
      for (let storeTypeCount of activityData.activityStoreTypeCount) {
        if (activityData.activityFormData.storeTypeName.includes("All") || activityData.activityFormData.storeTypeName.includes(storeTypeCount.storeTypeName)) {
          activityData.filterActivityStoreTypeCount.push(storeTypeCount);
          totalStoreTypeCount.quantity += storeTypeCount.quantity;
        } else {
          totalStoreTypeCount.quantity += storeTypeCount.quantity;
          otherStoreTypeCount.quantity += storeTypeCount.quantity;
        }
      }
      activityData.filterActivityStoreTypeCount.unshift(totalStoreTypeCount);
      if (otherStoreTypeCount.quantity > 0) {
        activityData.filterActivityStoreTypeCount.push(otherStoreTypeCount);
      }
      for (let storeTypeCount of activityData.filterActivityStoreTypeCount) {
        if (totalStoreTypeCount.quantity > 0) {
          let percentage = storeTypeCount.quantity / totalStoreTypeCount.quantity * 100;
          storeTypeCount.percentage = parseFloat((Math.round(percentage * 100) / 100).toString());
        } else {
          storeTypeCount.percentage = 0;
        }
      }
    };
    const storeTypeChange = async (values, options) => {
      if (values != null && values.length > 1) {
        if (values[values.length - 1] === "All") {
          activityData.activityFormData.storeTypeName = activityData.activityFormData.storeTypeName.filter(item => item === "All");
        } else {
          activityData.activityFormData.storeTypeName = activityData.activityFormData.storeTypeName.filter(item => item !== "All");
        }
      }
      refreshStoreTypeCount();
    };
    const filterTopRank = () => {
      activityData.filterActivityStoreRankCount.length = 0;
      if (isTop50.value === true) {
        activityData.filterActivityStoreRankCount.push(...activityData.activityStoreRankCount.slice(0, 50));
      } else {
        activityData.filterActivityStoreRankCount.push(...activityData.activityStoreRankCount.slice(0, 100));
      }
    };
    const top50Click = () => {
      isTop50.value = true;
      filterTopRank();
    };
    const top100Click = () => {
      isTop50.value = false;
      filterTopRank();
    };
    return (_ctx, _cache) => {
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_config_provider = _resolveComponent("a-config-provider");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_config_provider, {
        theme: {
          components: {
            Tabs: {
              fontSize: 18,
              colorPrimary: '#777777',
              colorText: '#C4C4C4',
              motionDurationMid: 0,
              motionDurationSlow: 0
            }
          }
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, {
          class: "sts-tabs default",
          activeKey: activeTabsKey.value,
          "onUpdate:activeKey": _cache[3] || (_cache[3] = $event => activeTabsKey.value = $event),
          type: "card",
          animated: false,
          onChange: changeTab
        }, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            key: "1",
            tab: "活动信息"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_a_select, {
              value: activityData.activityFormData.activityCategoryId,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => activityData.activityFormData.activityCategoryId = $event),
              placeholder: _ctx.$t('activityCreate.select'),
              size: "middle",
              style: {
                "min-width": "125px",
                "height": "39px",
                "margin-right": "19px"
              }
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix",
                style: {
                  "color": "#818181"
                }
              })]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.activityCategoryList, (item, index) => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  key: index,
                  value: item.activityCategoryId
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.activityCategoryName), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["value", "placeholder"]), _createVNode(_component_a_range_picker, {
              value: activityData.activityFormData.activityDateValue,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => activityData.activityFormData.activityDateValue = $event),
              format: ['YYYY-MM-DD', 'YYYY-MM-DD'],
              placeholder: [_ctx.$t('activityCreate.startTime'), _ctx.$t('activityCreate.endTime')],
              valueFormat: "YYYY-MM-DD",
              onChange: pickerChange,
              style: {
                "min-width": "265px",
                "height": "38px"
              }
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix",
                style: {
                  "color": "#818181",
                  "font-size": "24px"
                }
              })]),
              _: 1
            }, 8, ["value", "placeholder"]), _createVNode(_unref(Divider), {
              style: {
                "margin": "10px 10px",
                "flex": "1",
                "width": "auto",
                "min-width": "auto"
              }
            })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_unref(Divider), {
              style: {
                "margin": "10px",
                "flex": "1 1 0%",
                "width": "auto",
                "min-width": "auto"
              }
            })]), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_a_select, {
              onChange: storeTypeChange,
              mode: "multiple",
              "max-tag-count": 6,
              value: activityData.activityFormData.storeTypeName,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => activityData.activityFormData.storeTypeName = $event),
              placeholder: _ctx.$t('activityCreate.select'),
              size: "middle",
              style: {
                "min-width": "125px",
                "height": "39px",
                "margin-left": "18px"
              }
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix",
                style: {
                  "color": "#818181"
                }
              })]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.storeTypeData, (item, index) => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  key: index,
                  value: item
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["value", "placeholder"]), _createVNode(_unref(Divider), {
              style: {
                "margin": "10px",
                "flex": "1 1 0%",
                "width": "auto",
                "min-width": "auto"
              }
            })]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.filterActivityStoreTypeCount, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: {
                  "display": "flex",
                  "flex-direction": "column",
                  "align-items": "center",
                  "margin": "0px 15px"
                }
              }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(item.quantity), 1), _createElementVNode("div", _hoisted_19, " (" + _toDisplayString(item.percentage) + "%) ", 1)]), _createElementVNode("div", _hoisted_20, _toDisplayString(item.storeTypeName), 1)]);
            }), 128))])]), _hoisted_21]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_hoisted_24, _hoisted_25, _hoisted_26, _createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
              class: _normalizeClass([{
                active: isTop50.value
              }, "filter-button left"]),
              onClick: top50Click
            }, " TOP50 ", 2), _createElementVNode("div", {
              class: _normalizeClass([{
                active: isTop50.value === false
              }, "filter-button right"]),
              onClick: top100Click
            }, " TOP100 ", 2)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.filterActivityStoreRankCount, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: _normalizeStyle([{
                  "display": "flex",
                  "font-size": "12px",
                  "height": "30px",
                  "min-height": "30px",
                  "align-items": "center",
                  "color": "#777777"
                }, {
                  backgroundColor: (index + 1) % 2 === 0 ? '#f7f7f7' : '#ffffff'
                }])
              }, [_createElementVNode("div", _hoisted_30, _toDisplayString(index + 1 + "." + item.storeName), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(item.quantity), 1)], 4);
            }), 128))])])]), _hoisted_32])])])])]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            key: "2",
            tab: "店铺数据"
          }, {
            default: _withCtx(() => [_hoisted_33]),
            _: 1
          })]),
          _: 1
        }, 8, ["activeKey"])]),
        _: 1
      })])]);
    };
  }
};